// extracted by mini-css-extract-plugin
export default {"container":"forgot-password_container__3uO_3","description":"forgot-password_description__2nHlG","links":"forgot-password_links__2UftW"};